import { Box, IconButton } from "@material-ui/core";
import { ReferralResponseDto } from "../../../../../types/referrals";
import { GetApp } from "@material-ui/icons";
import i18nNamespaces from "../../../../../const/i18nNamespaces";
import { useTranslation } from "react-i18next";
import { DateTime } from "luxon";
import { getShortDateFromISO, getTimeFromISO } from "../../../../../utils/date";

type ReferralsListItemProps = {
    index: number;
    referral: ReferralResponseDto;
    onClickDownload: (referralId: string) => void;
}

export const ReferralsListItem = ({index, referral, onClickDownload}: ReferralsListItemProps) => {
    const {t} = useTranslation(i18nNamespaces.REFERRAL);
    const dt = DateTime.fromISO(referral.effectiveDateTime, { zone: 'utc' }).setZone(DateTime.local().zoneName);
    const date = dt.toLocaleString(DateTime.DATE_SHORT);
    const time = dt.toLocaleString(DateTime.TIME_24_SIMPLE);

    return (
        <Box style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            margin: '24px 0',
            alignItems: 'center',
        }}>
            <Box style={{
                display: 'flex',
                flexDirection: 'row',
                gap: 16,
                flexWrap: 'wrap'
            }}>
                <Box style={{ color: "#888" }}>
                    <span>
                        {date}
                    </span>
                    <span style={{ marginLeft: 8 }}>
                        {time}
                    </span>
                </Box>
                <Box>
                    {t(referral.type)}
                </Box>
                <Box>
                    {referral.orgUnitSpecialty.name}
                </Box>
                <Box>
                    Kod: {referral.code}
                </Box>
            </Box>
            <Box>
                <IconButton
                    size={'small'}
                    style={{marginLeft: 10}}
                    onClick={() => onClickDownload(referral.id)}
                >
                    <GetApp fontSize={'small'} color={'secondary'}/>
                </IconButton>
            </Box>
        </Box>
    );
}

export default ReferralsListItem;